import { LitElement, css, html } from 'lit';
import { customElement, property, query } from 'lit/decorators';

@customElement('form-textarea')
export class FormTextarea extends LitElement {
    @query('#form-textarea')
    formTextareaElement!: HTMLTextAreaElement;

    @property({ type: String })
    value?: string;

    @property({ type: String })
    type?: string;

    @property({ type: String })
    label?: string;

    @property({ type: String })
    placeholder?: string;

    @property({ type: String })
    maxLength?: string;

    @property({ type: Boolean })
    required?: boolean;

    @property({ type: Boolean })
    hideMaxLength?: boolean;

    private handleChange(e: Event) {
        this.value = (e.target as HTMLInputElement).value;
        this.dispatchEvent(
            new CustomEvent('change', {
                detail: e.target,
            })
        );
    }

    reportValidity() {
        return this.formTextareaElement?.reportValidity();
    }

    protected render() {
        const maxLimit = this.maxLength ? `${this.maxLength} chars` : '';

        return html`
            <div>
                <label class="form-label">
                    <span>${this.label}</span>
                    ${this.hideMaxLength === true ? '' : html`
                        <span class="max-limit">${maxLimit}</span>
                    `}
                </label>
                <textarea
                    id="form-textarea"
                    class="form-control"
                    type="${this.type}"
                    placeholder="${this.placeholder}"
                    maxlength="${this.maxLength}"
                    ${this.required === true ? 'required' : ''}
                    @change="${this.handleChange}"
                >${this.value}</textarea
                >
            </div>
        `;
    }

    static get styles() {
        return css`
            .form-label {
                line-height: 1rem;
                font-size: 0.8rem;
                color: var(--theme-input-color);
                display: flex;
                font-weight: 500;
                justify-content: space-between;
                align-items: flex-end;
            }

            .form-label .max-limit {
                color: var(--theme-lighter-text-color);
                padding-left: 1rem;
            }

            .form-control {
                resize: vertical;
                min-height: 7rem;
                display: block;
                width: 100%;
                box-sizing: border-box;
                margin-top: 0.25rem;
                padding: 10px;
                font-family: var(--custom-font), 'Montserrat', sans-serif !important;
                font-size: 0.75rem;
                line-height: 1.5;
                color: var(--theme-input-color);
                border: 1px solid var(--theme-input-border-color);
                background-color: var(--theme-white-color);
                background-clip: padding-box;
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                border-radius: 0.5rem;
                box-shadow: inset 0 1px 2px transparent;
                transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
                    box-shadow 0.15s ease-in-out;
            }

            .form-control:focus {
                border-color: var(--theme-focus-border-color);
                background-color: var(--theme-white-color);
                outline: 0;
            }

            .form-control::placeholder {
                color: var(--theme-lighter-text-color);
                opacity: 1;
            }
        `;
    }
}
